// import VeLine from 'v-charts/lib/line.common'


export default {
  data(){
    return{

    }
  },
  components:{
    VeLine(resolve){
      require(['v-charts/lib/line.common.min'],resolve)
    },
    VeHistogram(resolve){
      require(['v-charts/lib/histogram.common.min'],resolve)
    },
    VeBar(resolve){
      require(['v-charts/lib/bar.common.min'],resolve)
    },
    VePie(resolve){
      require(['v-charts/lib/pie.common.min'],resolve)
    },
    VeRing(resolve){
      require(['v-charts/lib/ring.common.min'],resolve)
    },
    VeWaterfall(resolve){
      require(['v-charts/lib/waterfall.common.min'],resolve)
    },
    VeFunnel(resolve){
      require(['v-charts/lib/funnel.common.min'],resolve)
    },
    VeRadar(resolve){
      require(['v-charts/lib/radar.common.min'],resolve)
    },
    VeMap(resolve){
      require(['v-charts/lib/map.common.min'],resolve)
    },
    VeSankey(resolve){
      require(['v-charts/lib/sankey.common.min'],resolve)
    },
    VeHeatmap(resolve){
      require(['v-charts/lib/heatmap.common.min'],resolve)
    },
    VeScatter(resolve){
      require(['v-charts/lib/scatter.common.min'],resolve)
    },
    VeCandle(resolve){
      require(['v-charts/lib/candle.common.min'],resolve)
    },
    VeGauge(resolve){
      require(['v-charts/lib/gauge.common.min'],resolve)
    },
    VeTree(resolve){
      require(['v-charts/lib/tree.common.min'],resolve)
    },
    VeLiquidfill(resolve){
      require(['v-charts/lib/liquidfill.common.min'],resolve)
    },
    VeWordcloud(resolve){
      require(['v-charts/lib/wordcloud.common.min'],resolve)
    },
  }
}